module.exports = __webpack_public_path__ + "static/media/10.486e3cb5.png";